import { render, staticRenderFns } from "./ArticlesTable.vue?vue&type=template&id=1b4a2763&"
import script from "./ArticlesTable.vue?vue&type=script&lang=js&"
export * from "./ArticlesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports